import React from 'react'
import './styles.css'

const AnimatedGradientLine = () => {
	return <div className="animated-gradient-line" />
}

export default AnimatedGradientLine
